import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from 'tmt-ui-kit';
import Link from '~/components/Link/Link';

const BredcrumbContainer = styled.div`
  padding-top: 16px;
  display: flex;
  align-items: center;
`;

const PrimaryPageName = styled.div`
  >a {
    color: ${props => props.theme.black};
  }
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: 4px;
  margin-left: 8px;
  margin-right: 8px;
`;

const ArrowIcon = styled(Icon)`
  font-size: 14px;
`;

const SecondaryPageName = styled.div`
  margin-top: -2px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: capitalize;
  color: ${props => props.theme.blue};
`;

class Bredcrumb extends Component {
  render() {
    const { title } = this.props;
    return (
      <BredcrumbContainer>
        <PrimaryPageName><Link to="/help-center">Help Center</Link></PrimaryPageName>
        <ArrowContainer>
          <div><ArrowIcon name="chevron-right" /></div>
        </ArrowContainer>
        <SecondaryPageName>{title}</SecondaryPageName>
      </BredcrumbContainer>
    );
  }
}

Bredcrumb.propTypes = {
  title: PropTypes.string
};

export default Bredcrumb;
